// ----------------------------------------------------------------------
// <copyright file="Izenda.Footer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Footer component
 */
!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');

  var ActionBar = require('share/components/controls/Izenda.ActionBar');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var convertToDateTimeFormat = require('share/utils/Izenda.ConvertToDateTimeFormat');
  var uiState = require('logic/Izenda.UiState');

  var Footer = React.createClass({
    render: function () {
      var detail = this.props.detail;
      var createdDate = convertToDateTimeFormat(uiState.currentUser.dateFormat, detail.created);
      var modifiedDate = convertToDateTimeFormat(uiState.currentUser.dateFormat, detail.modified);
      var localization = this.props.localization;

      return (
        <GridLayout>
          <GridLayout.Row>
            <GridLayout.Col cols={3}>
              <span>{localization.getText('COMMON_LABEL_CREATED')}: </span>
              <span className='date-text'>{createdDate || detail.createdAsString}</span>
            </GridLayout.Col>
            <GridLayout.Col cols={9}>
              <span>{localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_LAST_MODIFIED')}: </span>
              <span className='date-text'>{modifiedDate}</span>
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      );
    }
  });

  module.exports = connect()(Footer);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/HeaderSection/Izenda.Footer.jsx